<template>
    <div class="editor-title-toolbar">
        <ReturnButton
            class="return-btn"
            @click="clickReturn"
            v-show="showReturnBtn !== null && showReturnBtn !== false"
            :label="returnText"
        />

        <div>
            <h2 v-show="null != titleLabel">{{titleLabel}}</h2>
            <h2 v-show="null == titleLabel">&nbsp;</h2>
        </div>

        <div class="right-operation-btn">
            <el-button :type="btnType" v-show="showReturnBtn !== null && showOperationBtn !== false" @click="clickOperation">{{operationLabel}}</el-button>
            &nbsp;
        </div>
    </div>
</template>

<script setup>

import ReturnButton from "@/components/shopopee/common/returnButton.vue";
import {inject, computed} from "vue";

const props = defineProps([
    "showReturnBtn",
    "returnLabel",
    "titleLabel",
    "showOperationBtn",
    "operationLabel",
    "operationType"
])
const emits = defineEmits(["clickReturnBtn", "clickOperationBtn"])

const i18n = inject("i18n")

const returnText = computed(() => {
    let text = i18n.tkey("lang_return")

    if (null != props.returnLabel){
        text = props.returnLabel
    }

    return text
})

const btnType = computed(() => {
    let text = "primary"

    if (null != props.operationType){
        text = props.operationType
    }

    return text
})

function clickReturn(){
    emits("clickReturnBtn")
}

function clickOperation(){
    emits("clickOperationBtn")
}

</script>

<style scoped>
.editor-title-toolbar {
    text-align: center;
    position: relative;
    margin-bottom: 32px;
}

.editor-title-toolbar .return-btn {
    position: absolute;
    left: 0;
    top: 5px;
}

.editor-title-toolbar .right-operation-btn {
    position: absolute;
    right: 0;
    top: 0;
}

h2 {
    margin-top: 0;
}
</style>